// extracted by css-extract-rspack-plugin
export default {"icon":"icon-Kr3Xfr","dangle":"dangle-Hty16c","active":"active-uV0M17","opened":"opened-nmoKz4","arrowContainer":"arrowContainer-tmDRwf","notification":"notification-Av9Cz3"};